import { Box } from '@hover/blueprint';
import React from 'react';
import { useLocation } from 'react-router';
import { animated } from 'react-spring';

import { Spacer } from 'src/shared/components';
import {
  CanonicalLink as MetaCanonicalLink,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { isServer } from 'src/shared/helpers/environment';
import { baseUrlToLoginSuccessUrl } from 'src/shared/helpers/url';
import { useTranslate } from 'src/shared/hooks';
import { TwoColumn } from 'src/shared/layouts';
import { SingleSignOnProvider } from 'src/shared/providers';
import { Route } from 'src/shared/route';
import { useSlide } from 'src/shared/transitions';

import { Footer } from './Footer';
import { Form } from './Form';

const AnimatedHeader = animated(TwoColumn.Header);

const Login = () => {
  const t = useTranslate('login');
  const { pathname } = useLocation();

  const isSingleSignOnRoute = pathname === Route.LOGIN_SSO.path;

  const transitions = useSlide(isSingleSignOnRoute);

  const conditionals = isSingleSignOnRoute
    ? {
        path: Route.LOGIN_SSO.path,
        title: t('logIntoYourSingleSignOnHoverAccount'),
      }
    : {
        path: Route.LOGIN.path,
        title: t('logIntoYourHoverAccount'),
      };

  const singleSignOnRedirectPath = isServer()
    ? ''
    : baseUrlToLoginSuccessUrl(window.location.href);

  return (
    <SingleSignOnProvider
      isActive={isSingleSignOnRoute}
      redirectPath={singleSignOnRedirectPath}
    >
      <MetaCanonicalLink pathname={conditionals.path} />
      <MetaTitle title={conditionals.title} />
      <Box alignItems="center" flexDirection="column" position="relative">
        {transitions.map(({ item, key, props: style }) =>
          item ? (
            <AnimatedHeader
              heading={t('singleSignOn.singleSignOn')}
              key={key}
              style={style}
              subheading={t('singleSignOn.pleaseSignIn')}
            />
          ) : (
            <AnimatedHeader
              heading={t('welcomeBack')}
              key={key}
              style={style}
              subheading={t('enterYourAccountDetailsToLogin')}
            />
          ),
        )}
      </Box>
      <TwoColumn.Main>
        <Form />
      </TwoColumn.Main>
      <Spacer count={2} />
      <Footer />
    </SingleSignOnProvider>
  );
};

export { Login };
